/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Auth from '../Auth';
import Link from '../../../../../components/Link';
import Callout from '../../../../../components/Callout';
import Form from '../../../../../components/Form';
import Password from '../../../../../components/Form/Input/Password';
import history from '../../../../../history';
import {
  isValidPassword,
  PASSWORD_HELP_TEXT,
  PASSWORD_ERROR_TEXT,
} from '../../../../../core/passwordPolicy';

const messages = defineMessages({
  instructions: {
    id: 'auth.reset.instructions',
    defaultMessage: 'Your password has successfully been updated.',
    description: 'Instructions to reset password',
  },
  login: {
    id: 'auth.reset.login',
    defaultMessage: 'LOGIN',
    description: 'Login Link',
  },
  signup: {
    id: 'auth.reset.signup',
    defaultMessage: 'SIGN UP',
    description: 'Sign Up Link',
  },
  member: {
    id: 'auth.reset.member',
    defaultMessage: 'Already member on mySKP?',
    description: 'Already member',
  },
  memberLogin: {
    id: 'auth.reset.memberLogin',
    defaultMessage: 'Log in',
    description: 'Log in Link',
  },
});

class Reset extends Component {
  static contextTypes = {
    url: PropTypes.object.isRequired,
    routeParams: PropTypes.object.isRequired,
    fetch: PropTypes.func.isRequired,
  };

  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      submitting: false,
      submitSuccess: false,
      submitError: false,
      value: {},
    };
  }

  componentDidMount() {
    const { session } = this.props; //eslint-disable-line
    const { url, routeParams } = this.context;
    if (session.USER_DATA) {
      history.replace(url.getUrl('home', routeParams));
    }
  }

  async submitHandler(e) {
    const { siteId, token } = this.context.routeParams;
    this.setState({
      submitting: true,
      value: e.value,
      submitSuccess: false,
      submitError: false,
    });

    const resp = await this.context.fetch(`/${siteId}/auth/reset/${token}`, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        password: e.value.password,
      }),
      credentials: 'include',
    });
    const data = await resp.json();
    if (!data || resp.status !== 200) {
      this.setState({ submitError: true, submitting: false });
    } else {
      this.setState(
        { submitting: false, submitSuccess: true, value: {} },
        () => {
          history.push(`/${siteId}/auth`);
        },
      );
    }
  }

  render() {
    const { url, routeParams } = this.context;

    let callout;
    if (this.state.submitSuccess) {
      callout = (
        <Callout size="small" type="success">
          <FormattedMessage {...messages.instructions} />
        </Callout>
      );
    } else if (this.state.submitError) {
      callout = (
        <Callout size="small" type="warning">
          <FormattedMessage {...messages.instructions} />
        </Callout>
      );
    }

    return (
      <Auth>
        <div className="auth__form">
          <div className="flex-center auth__links">
            <Link
              className="link link--medium"
              to={url.getUrl('auth-index', routeParams)}
              activeClassName="is-active"
            >
              <FormattedMessage {...messages.login} />
            </Link>
            <Link
              className="link link--medium"
              to={url.getUrl('auth-register', routeParams)}
              activeClassName="is-active"
            >
              <FormattedMessage {...messages.signup} />
            </Link>
          </div>

          {callout}

          <div className="auth__main">
            <Form
              title={this.props.title}
              onValidSubmit={this.submitHandler.bind(this)}
              isSubmitting={this.state.submitting}
              submitButtonLabel={
                this.state.submitting ? '...submitting' : 'UPDATE PASSWORD'
              }
              value={this.state.value}
            >
              <Password
                label="New Password"
                helpText={PASSWORD_HELP_TEXT}
                errorText={PASSWORD_ERROR_TEXT}
                name="password"
                validators={isValidPassword}
                required
              />
            </Form>
          </div>

          <p className="auth__help">
            <FormattedMessage {...messages.member} />{' '}
            <Link
              className="auth__link"
              to={url.getUrl('auth-index', routeParams)}
            >
              <FormattedMessage {...messages.memberLogin} />
            </Link>
          </p>
        </div>
      </Auth>
    );
  }
}

// export default Login;
export default connect(state => ({ session: state.session }))(Reset);



// WEBPACK FOOTER //
// ./src/routes/client/site/auth/password-reset/Reset.js